<script>

    import { toast } from 'bulma-toast'

    import TrackingsService from '../$services/trackings.service'

    import DateMethods from '../$methods/date.methods'

    import Button from '../$components/button.svelte'
    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'
    import Image from '../$components/image.svelte'

    let data = { guide: '' }
    let loading = false
    let tracking = null

    async function findTrackingShipment() {

        loading = true
        const resp = await TrackingsService.findTrackingShipment(data)
        loading = false

        data.guide = ''

        if(!resp.success) {
            tracking = 'error'
            return toast({message: resp.error.message, type: 'is-danger'})
        }

        tracking = resp.data

    }

</script>

<style>

    .body {
        background-color: #3033AF;
        background-image: linear-gradient(90deg, #3033AF 0%, #B36BE1 100%);
        height: 100vh;
        overflow-y: scroll;
    }

    .centerContent {
        display: flex;
        justify-content: center;
    }
    .content {
        background: white;
        padding: 32px;
        border-radius: 16px;
        min-width: 25vw;
    }

</style>

<div class="body">
    <div class="centerContent">
        <div class="content space bottom top">
            <div class="items center">
                <Image src="/images/brand.png" size="128x128" />
            </div>
            <hr>

            {#if !tracking}

                <Form on:submit={findTrackingShipment} hideCancel={true} textSave="Rastrear" iconSave="search" {loading} >
                    <InputText bind:value={data.guide} label="Número de guía" icon="box" placeholder="Número de guía" />
                </Form>

            {:else if tracking === 'error'}

                <article class="message is-link">
                    <div class="message-body">
                        No se encontró ese número de guía.
                    </div>
                </article>
                <Button on:click={() => tracking = null} text="Rastrear otro paquete" icon="box" color="primary" fullwidth={true} />

            {:else if tracking.length}
                <div class="space bottom">
                    <div class="timeline">
                        <header class="timeline-header">
                        <span class="tag is-medium is-primary">Inicio</span>
                        </header>
                        {#each tracking as item}
                            <div class="timeline-item ">
                                <div class="timeline-marker">
                                </div>
                                <div class="timeline-content">
                                    <p class="heading">{ DateMethods.dateTimeLarge(item.created) }</p>
                                    <div>
                                        <div class="title is-5">{ item.name }</div>
                                        <div class="subtitle is-6">{ item.details }</div>
                                    </div>
                                </div>
                            </div>
                            {#if item.status === 'Entregado'}
                                <div class="timeline-header">
                                    <span class="tag is-medium is-primary">Finalizado</span>
                                </div>
                            {/if}
                        {/each}
                    </div>
                </div>

                <Button on:click={() => tracking = null} text="Rastrear otro paquete" icon="box" color="primary" fullwidth={true} />

            {:else}

                <article class="message is-link">
                    <div class="message-body">
                        Su guía aún no cuenta con movimientos, por favor revise más tarde...
                    </div>
                    <Button on:click={() => tracking = null} text="Rastrear otro paquete" icon="box" color="primary" fullwidth={true} />
                </article>

            {/if}
        </div>
    </div>
</div>